
const Mediator = {
  instance() {
    if (!SingletonAreas.instance) {
      SingletonAreas.instance = this;
    }
    return SingletonAreas.instance;
  },

  kpiPGDIMaping: new Map(),
  kpiGDIMaping: new Map(),
  kpisRelatedList: [],

  notify(sender, event) {
    if (event == "remove") {
      remove(sender)
    }

    if (event == "insert") {
      insert(sender)
    }

    if (event == "loading") {
      loading(sender)
    }

    if(event == "refreshPgdiList"){
      refreshPGDI(sender)
    }
    if(event == "refreshGdiList"){
      refreshGDI(sender)
    }
  },
}

export default Mediator

function loading(indicators){
  indicators.pgdi.forEach(kpi => Mediator.kpiPGDIMaping.set(kpi.key, kpi));
  indicators.gdi.forEach(kpi => Mediator.kpiGDIMaping.set(kpi.key, kpi));
  Mediator.kpisRelatedList = indicators.related

  Mediator.kpisRelatedList.forEach((i, count) => {
    let pgdi = indicators.pgdi.find(j => j.indicatorId == i.pgdiIndicadorId)
    let gdi = indicators.gdi.find(j => j.indicatorId == i.gdiIndicatorId)
    if(!pgdi || !gdi) return
    setTimeout(() => {
      let keyGdi = gdi.key;
      let keyPgdi = pgdi.key;
      selectIndicator(keyPgdi);
      creaElementPGDI(keyGdi, keyPgdi, pgdi.indicatorName);
    }, 5 * count)
  }) 
}


function insert(key){ 
  let kpiGDI = Mediator.kpiGDIMaping.get(key.gdi)
  let kpiPGDI = Mediator.kpiPGDIMaping.get(key.pgdi)

  if(!kpiGDI || !kpiPGDI){
    return 
  }


  let isRelated = Mediator.kpisRelatedList.find(i => i.pgdiIndicadorId == kpiPGDI.indicatorId)

  if(isRelated && isRelated.gdiIndicatorId == kpiGDI.indicatorId) return;

  if(isRelated && !key.force){
    key.dialog() 
    return
  }

  if(!isRelated) {
    selectIndicator(key.pgdi)
  }

  creaElementPGDI(key.gdi, key.pgdi, kpiPGDI.indicatorName)

  let relatedIndicator = {
    pgdiIndicadorId: kpiPGDI.indicatorId,
    productionUnitId: kpiPGDI.productionUnitId,
    gdiIndicatorId: kpiGDI.indicatorId,
  }

  Mediator.kpisRelatedList.push(relatedIndicator);
}

function creaElementPGDI(keyGdi, keyPgdi,  name){
  let gdiElement = document.getElementById(keyGdi)
  if(!gdiElement) return;

  let appendPgdi = document.createElement('p');
  if(!appendPgdi) return
  
  let spanClose = document.createElement('span');
  let span = document.createElement('span');
  
  appendPgdi.innerHTML = "[PGDI] - " + name;
  appendPgdi.style["margin"] = "0px"

  spanClose.innerHTML = "x";
  spanClose.title = "Clique para desvincular";
  spanClose.style.cursor = "pointer";
  spanClose.style["text-indent"] = "0"
  spanClose.style["padding"] = "0 6px"
  spanClose.style["border-radius"] = "4px"
  spanClose.style["margin-left"] = "4px"
  spanClose.style["transition-duration"] = "100ms"

  let keyRelated = keyGdi + "_" + keyPgdi;
  span.id = keyRelated;
  span.style.display = "flex"
  span.style["alignItems"] = "base"
  span.style["alignItems"] = "base"
  span.style["margin"] = 0,
  span.style["text-indent"] = "1.8vh",
  span.style["font-size"] = "1rem",
  span.style["font-weight"] = 700, 
  span.style["heigth"] = "15px", 

  spanClose.addEventListener("mouseover", () => spanClose.style["boxShadow"] = "0 0 3px #0009")
  spanClose.addEventListener("mouseout", () => spanClose.style["boxShadow"] = "none")
  spanClose.addEventListener("click", () => removeReletedPgdi(keyRelated))

  span.appendChild(appendPgdi);
  span.appendChild(spanClose);
  gdiElement.appendChild(span)
}

function selectIndicator(key){
  let indicator = document.getElementById(key)
  if(indicator){
      indicator.classList.add("select-indicatorList")
  }
}


function removeReletedPgdi(keyGdi_pgdi){
  let indicator = document.getElementById(keyGdi_pgdi)
  
  if(indicator) indicator.parentNode.removeChild(indicator)

  let keypgdi = keyGdi_pgdi.split("_").length > 1 ? keyGdi_pgdi.split("_") : null
  if(!keypgdi[1]) return

  let idPgdi = parseInt(keypgdi[1].split("_")[0])
  let idGdi = parseInt(keypgdi[0].split("_")[0])

  let moreThanOne = Mediator.kpisRelatedList.filter(i => i.pgdiIndicadorId == idPgdi)

  let el = document.getElementById(keypgdi[1])
  if(!el) return

  moreThanOne.length == 1 && el.classList.remove("select-indicatorList");
  
  let index = Mediator.kpisRelatedList.findIndex(r => {
    return r.pgdiIndicadorId == idPgdi && r.gdiIndicatorId == idGdi
  })
  
  Mediator.kpisRelatedList.splice(index, 1)
}

function refreshPGDI(filteredPgdis){
  let count = 0;
  for (const pgdi of filteredPgdis) {
    let isRelated = Mediator.kpisRelatedList.find(i => i.pgdiIndicadorId == pgdi.indicatorId)
    if(isRelated)
      setTimeout(() => selectIndicator(pgdi.key), 10 * count++);
  }
}

function refreshGDI(filteredGdis){
  let count = 0;
  for (const gdi of filteredGdis) {
    let isRelated = Mediator.kpisRelatedList.filter(i => i.gdiIndicatorId == gdi.indicatorId)
    let pgdi = null
    
    isRelated.forEach(r => {
      let key = `${r.pgdiIndicadorId}-${r.productionUnitId}-P`
      if(Mediator.kpiPGDIMaping.has(key)){
        let pgdi = Mediator.kpiPGDIMaping.get(key)

        setTimeout(() => {
          let alreadyRendered = document.getElementById(gdi.key +"_"+ pgdi.key)

          if(!alreadyRendered)
            creaElementPGDI(gdi.key, pgdi.key, pgdi.indicatorName)}, 10 * count++);
      }
    })
  }
}